import { 
  FormControl, 
  Select, 
  MenuItem, 
  InputLabel, 
  FormHelperText, 
} from "@mui/material"
import useLangs from "@/languages/hooks/useLangs";
import { useTranslation } from "react-i18next";
import { Controller, FieldValues, Path, useFormContext } from "react-hook-form";

type LangSelectFieldProps<TForm extends FieldValues> = {
  name: Path<TForm>;
  label: string;
  readOnly: boolean;
}

const LangSelectField = <TForm extends FieldValues>({
  name,
  label,
  readOnly
}: LangSelectFieldProps<TForm>) => {
  const { t } = useTranslation();

  const { availableLangsData } = useLangs();

  const { control } = useFormContext<TForm>();

  return (
    <div>
      <Controller<TForm>
        name={name}
        control={control}
        render={({field, fieldState}) => (<>
          <FormControl style={{ width: "100%" }}>
            <InputLabel shrink htmlFor="" id="lang-select-label">
            {(label || t('common:text.langselect_language'))}*
            </InputLabel>
            <Select
              labelId="lang-select-label"
              {...field}
              autoWidth={true}
              disabled={readOnly}
            >
              {(availableLangsData.map((lang) => (
                <MenuItem
                  key={lang.value}
                  value={lang.value}
                >
                  {lang.display}
                </MenuItem>
              )))}
            </Select>
          </FormControl>
          {fieldState.error && fieldState.error.message && (
            <FormHelperText error={true} id="lang-select-error-text">
              {fieldState.error.message}
            </FormHelperText>
          )}
        </>)}
      />
    </div>
  );
};

export default LangSelectField;